import { render } from "./reopenTicket.vue?vue&type=template&id=7dea7438"
import script from "./reopenTicket.vue?vue&type=script&lang=js"
export * from "./reopenTicket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__